import { animate, state, style, transition, trigger } from '@angular/animations';

export const CartShow = trigger('cartShow', [
  state('false', style({ bottom: '-3.25rem', opacity: 0 })), // height of cart button with margins
  state('true', style({ bottom: '0px', opacity: 1 })),
  transition('false => true', animate('0.3s ease-out')),
  transition('true => false', animate('0.3s ease-in'))
]);
